import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Moon = ({
  styles,
  className = '~w-3/6 ~h-3/6',
  fill = COLOR.PRIMARY.LIGHT_900,
  fillDarkMode = COLOR.PRIMARY.LIGHT_100
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={styles || className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M33.1667 20.7975C31.1672 21.865 28.8835 22.4703 26.4585 22.4703C18.5818 22.4703 12.1965 16.085 12.1965 8.20821C12.1965 5.78322 12.8017 3.49959 13.8694 1.50012C6.77942 3.16176 1.5 9.52534 1.5 17.122C1.5 25.9833 8.6835 33.1668 17.5448 33.1668C25.1415 33.1668 31.505 27.8875 33.1667 20.7975Z'
        fill={fillColor}
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Moon;
